// extracted by mini-css-extract-plugin
var _1 = "chevronButton__YNfSP";
var _2 = "chevronWrapper__qumbL";
var _3 = "main__C94c2";
var _4 = "text__w6P2d";
export { _1 as "chevronButton", _2 as "chevronWrapper", _3 as "main", _4 as "text" }
export default { "chevronButton": _1, "chevronWrapper": _2, "main": _3, "text": _4 }
